import {
  Inventory as ContainerIcon,
  Book as BookIcon,
  AttachMoney as FinanceIcon,
  Handyman as RepairIcon,
  Monitor as MonitorIcon,
  Api as ERPIcon,
} from '@mui/icons-material';
import ImplementingFeatureImg from '../images/Implementing-Feature.png';
import ImplementingWithoutTezport from '../images/Implementing-Without-Tezport.png';
import ImplementingTezport from '../images/Implementing-Tezport.png';
import ReviewPerson1 from '../images/ReviewPerson1.png';
import ReviewPerson2 from '../images/ReviewPerson2.png';

export const LANDING = {
  NAV: {
    HERO: 'Hero',
    KEY_FEATURES: 'Key Features',
    WHY_CHOOSE: 'Why Choose',
    IMPLEMENTING: 'Implementing',
    REVIEWS: 'Reviews',
    CONTACT_US: 'Contact us',
    REQUEST_DEMO: 'Request Demo',
    SUBMIT_REQUEST: 'Submit Request',
  },
  HERO: {
    TITLE: 'Hero',
    BODY_HEADER: 'Container Depot Software for Efficient Terminal Operations',
    BODY: 'Automate your container yard with TEZPORT — inventory, gate control, billing, repair tracking and slot booking in one place. Cloud-based. Fast setup. ERP integration ready.',
  },
  AUTOMATION: {
    TITLE: 'Why Depot Operations Need Automation',
    BODY: 'Manual processes and Excel lead to container delays, errors, customer complaints and lost revenue.',
    ITEMS: [
      'Lack of visibility — containers are misplaced',
      'Excel is not scalable — causes mistakes',
      'Requests handled manually — slow turnaround',
      'No equipment monitoring — low efficiency',
      'Manual billing — lost income opportunities',
    ],
  },
  KEY_FEATURES: {
    TITLE: 'Key Features of TEZPORT Container Depot Software',
    ITEMS: [
      {
        ICON: ContainerIcon,
        HEAD: 'Container Management',
        BODY: 'Gate-in/gate-out tracking, inventory, movement history',
      },
      {
        ICON: BookIcon,
        HEAD: 'Slot Booking System',
        BODY: 'Digital scheduling to eliminate queues and delays',
      },
      {
        ICON: FinanceIcon,
        HEAD: 'Finance & Billing Automation',
        BODY: 'Accurate invoicing, payments and reports',
      },
      {
        ICON: RepairIcon,
        HEAD: 'Repair & Maintenance Logs',
        BODY: 'Track container repairs, inspection and cleaning',
      },
      {
        ICON: MonitorIcon,
        HEAD: 'IoT Equipment Monitoring',
        BODY: 'Real-time view of cranes, forklifts, and movements',
      },
      {
        ICON: ERPIcon,
        HEAD: 'ERP & Excel Integration',
        BODY: 'Easily sync with your current TMS or ERP system',
      },
    ],
  },
  WHY_CHOOSE: {
    TITLE: 'Why Choose TEZPORT',
    ITEMS: [
      'Up to 40% fewer tracking errors',
      '30% faster customer request handling',
      'Go live in 1 day with full support',
      'Secure cloud storage and backup',
      'Works on mobile, tablet, and desktop',
      'Scales for terminals of all sizes',
    ],
  },
  IMPLEMENTING: {
    TITLE: 'Before and After Implementing TEZPORT',
    CARDS: [
      {
        IMG: ImplementingFeatureImg,
        TITLE: 'Feature',
        ITEMS: [
          'Container Tracking',
          'Slot Booking',
          'Repair Logs',
          'Billing & Invoicing',
          'Operations Visibility',
        ],
      },
      {
        IMG: ImplementingWithoutTezport,
        TITLE: 'Without TEZPORT',
        ITEMS: [
          'Excel spreadsheets',
          'Manual phone/email',
          'Paper notes',
          'Manual and delayed',
          'Fragmented tools',
        ],
      },
      {
        IMG: ImplementingTezport,
        TITLE: 'With TEZPORT',
        ITEMS: [
          'Cloud-based with real-time updates',
          'Digital and instant',
          'Automated logs with alerts',
          'Real-time automated billing',
          'Unified platform dashboard',
        ],
      },
    ],
  },
  REVIEWS: {
    TITLE: 'What Depot Operators Say About TEZPORT',
    ITEMS: [
      {
        IMG: ReviewPerson1,
        NAME: 'Jean Pierre',
        JOB: 'Software enginner',
        DATE: '22 April 2025',
        REVIEW: `🗨️ “We moved from Excel to TEZPORT in one day. Now all requests, reports, and tracking are digital and centralized.”
 — Depot Director, Dubai`,
      },
      {
        IMG: ReviewPerson2,
        NAME: 'Hans Peter',
        JOB: 'Data Scienties',
        DATE: '22 April 2025',
        REVIEW: `🗨️ “No more paper-based operations. My team can process container releases and inspections from any device.”
 — Terminal Supervisor, Turkey`,
      },
    ],
  },
  FAQ: {
    TITLE: 'Frequently Asked Questions',
    ITEMS: [
      {
        QUESTION: 'Is it secure?',
        ANSWER: 'Yes, TEZPORT uses encrypted cloud servers with access controls and daily backups.',
      },
      {
        QUESTION: 'Can we switch from Excel?',
        ANSWER: 'Absolutely. We offer full import support and onboarding assistance.',
      },
      {
        QUESTION: 'How long does setup take?',
        ANSWER: 'You can be live within 1 business day. No development needed on your side.',
      },
      {
        QUESTION: 'Does it integrate with our ERP?',
        ANSWER: 'Yes, TEZPORT supports API integrations and Excel-based workflows.',
      },
    ],
  },
  FINAL_CTA: {
    TITLE: 'Ready to Automate Your Depot?',
    SUB_TITLE:
      'Request a free demo and discover how TEZPORT can modernize your terminal operations.',
  },
  CONTACT_US: {
    TITLE: 'TEZPORT CONTAINER DEPOT SOFTWARE',
    ITEM_PHONE: '📞 Phone: +998 XX XXX XX XX',
    LINK_PHONE: '+998 XX XXX XX XX',
    ITEM_EMAIL: '📧 Email: info@tezport.uz',
    LINK_EMAIL: 'info@tezport.uz',
    ITEM_CHATS: ['✈️ Telegram', '💬 WhatsApp', '🗨️ WeChat'],
    LINK_CHATS: ['', '', ''],
  },
};
